import { render, staticRenderFns } from "./HospitalsManagement.vue?vue&type=template&id=37ad7a8b"
import script from "./HospitalsManagement.vue?vue&type=script&lang=js"
export * from "./HospitalsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports